<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    isActionVisible: {
      type: Boolean,
      default: true
    },
    actionCallback: {
      type: Function,
    },
    actionCallbackIcon: {
      type: String,
      default: 'mdi-autorenew'
    },
    actionTooltipText: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <v-row>
    <v-col cols="12">
      <h3 class="float-left">{{ title }}</h3>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-btn v-if="isActionVisible" class="float-right" icon color="primary" v-on="on" @click="actionCallback">
            <v-icon>{{ actionCallbackIcon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ actionTooltipText }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
